import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../utils/axios";
import { buildAssetUrl } from "../../utils/url";
import BottomNav from "../../components/layouts/BottomNav";

const API_BASE = ((process.env.REACT_APP_BASE_URL || "http://localhost:5000/").replace(/\/$/, "")) + "/";


const CategoriesPage = () => {
  const [categories, setCategories] = useState([]);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/categories")
      .then(res => setCategories(res.data))
      .catch(() => setCategories([]));
  }, []);

  const filteredCategories = categories.filter(cat =>
    cat.name.toLowerCase().includes(search.toLowerCase())
  );

  const handleCategoryClick = (cat) => {
    navigate(`/products?category=${cat.id}`);
  };

  return (
    <div style={{ background: "#fff", minHeight: "100vh", paddingBottom: 70 }}>
      {/* Top Bar with Back Icon and Page Title */}
      <div style={{
        padding: "14px 0 0 0",
        borderBottom: "1px solid #f4f4f4",
        display: "flex",
        flexDirection: "column",
        position: "sticky",
        top: 0,
        background: "#fff",
        zIndex: 12
      }}>
        {/* Row: Back Button + Page Title */}
        <div style={{
          display: "flex", alignItems: "center", gap: 0,
          padding: "0 14px 10px 6px"
        }}>
          {/* Back Button */}
          <button
            onClick={() => navigate(-1)}
            style={{
              background: "none",
              border: "none",
              padding: 0,
              marginRight: 10,
              display: "flex",
              alignItems: "center",
              cursor: "pointer"
            }}
            aria-label="Back"
          >
            <svg width="25" height="25" viewBox="0 0 24 24" fill="none"
              stroke="#222" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="15 18 9 12 15 6" />
            </svg>
          </button>
          <div style={{
            fontWeight: 700,
            fontSize: 21,
            color: "#232323",
            letterSpacing: "0.2px",
            marginTop: 2
          }}>
            Collections
          </div>
        </div>
        {/* Search Bar */}
        <form
          onSubmit={e => e.preventDefault()}
          style={{ padding: "0 14px 14px 14px" }}
        >
          <div style={{
            display: "flex",
            alignItems: "center",
            background: "#fafbfc",
            borderRadius: 12,
            border: "2px solid #353535",
            boxShadow: "0 1px 8px 0 rgba(0,0,0,0.04)",
            padding: "5px 12px"
          }}>
            <svg width="19" height="19" fill="none" stroke="#888" strokeWidth="2" style={{ marginRight: 7 }} viewBox="0 0 24 24">
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
            <input
              value={search}
              onChange={e => setSearch(e.target.value)}
              type="text"
              placeholder="Search category"
              style={{
                border: "none",
                outline: "none",
                background: "transparent",
                fontSize: 15,
                color: "#222",
                flex: 1,
                padding: 6
              }}
            />
          </div>
        </form>
      </div>

      {/* Categories Grid */}
      <div style={{
        padding: "10px 9px 0 9px",
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: 12
      }}>
        {filteredCategories.length === 0 && (
          <div style={{ gridColumn: "span 2", textAlign: "center", color: "#aaa", padding: 32 }}>
            No categories found.
          </div>
        )}
        {filteredCategories.map(cat => (
          <div key={cat.id}
            onClick={() => handleCategoryClick(cat)}
            style={{
              cursor: "pointer",
              borderRadius: 12,
              boxShadow: "0 1px 6px 0 rgba(40,44,63,0.05)",
              background: "#fafbfc",
              padding: "10px 7px 11px 7px",
              textAlign: "center",
              transition: "box-shadow 0.14s",
              border: "1px solid #f2f2f2"
            }}>
            <div style={{
              width: "100%",
              aspectRatio: "1/1",
              borderRadius: 8,
              overflow: "hidden",
              background: "#f1f1f1",
              marginBottom: 8
            }}>
              <img
                src={buildAssetUrl(cat.image_path)}
                alt={cat.name}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover"
                }}
              />
            </div>
            <div style={{
              fontWeight: 600,
              fontSize: 15,
              color: "#233045",
              letterSpacing: "0.05px",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden"
            }}>{cat.name}</div>
          </div>
        ))}
      </div>

      {/* Bottom Navigation */}
      <BottomNav />
    </div>
  );
};

export default CategoriesPage;
